import React from 'react'

const Header = ( { listView } ) => {
  return (
    <>
      <h1 style={{ fontWeight: 100, fontSize: '24px' }}>List Management</h1>

      {/* Temporary, till we have Project Lists ready */}
      {!listView && (
        <div style={{ display: 'flex', fontSize: '18px' }}>
          <p style={{
            borderBottom: '1px solid rgb(66, 155, 220)',
            padding: '2px',
            cursor: 'pointer',
            font: 'normal 16px Roboto',
            letterSpacing: ' 0.1px',
            color: '#429ADC',
            width: '90px',
            height: '29px'
          }}>
            Expert Lists
          </p>
          <p style={{
            color: '#b8b8b8',
            padding: '2px',
            cursor: 'pointer',
            font: 'normal 16px Roboto',
            letterSpacing: ' 0.1px',
            height: '29px',
            marginLeft: '16px',
            cursor: 'inherit'
          }}>
            Project Lists
          </p>
        </div>
      )}
    </>
  )
}

export default Header
